import { render, staticRenderFns } from "./BlogsGrid.vue?vue&type=template&id=658aef3d&scoped=true"
import script from "./BlogsGrid.vue?vue&type=script&lang=js"
export * from "./BlogsGrid.vue?vue&type=script&lang=js"
import style0 from "./BlogsGrid.vue?vue&type=style&index=0&id=658aef3d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "658aef3d",
  null
  
)

export default component.exports